import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class LegalEntitiesApi extends ApiModule {
	constructor() {
		super(ModulesMap.LEGAL_ENTITIES, {
			entity: 'legal_entities',
		})
	}
}
